import { Box, Grid } from "@material-ui/core";
import { Button, IconButton, TextField, Typography } from "@mui/material";
import NearMeIcon from "@mui/icons-material/NearMe";
import "./ReportsTile.css";
import { useNavigate } from "react-router-dom";
import { downloadReportAttributes, downloadReportRequestBody, reportListObject } from "../types/types";
import RenderSvg from "../../../components/renderSvg/RenderSvg";
import { downloadReport, downloadReportOfID, task } from "../../../services/reportService";
import { downloadNewReport, NewReportRequestBody } from "../../../services/newReportService";
import { openPopup } from "../../../stateManagement/actions/popupActions";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { fileFormat } from "../../../types/types";
import DownloadLoader from "../../../components/popup/downloadLoader";
import { ConfirmationPopUp } from "../../../components/popup/confirmationPopUp";
import ReportDownloadModal from "../download/utils/ReportDownloadModal";
import { TranslationEnum, usePortalTranslation } from "../../../providers/TranslationProvider";
import { Modal } from "@mantine/core";
import { ChannelkartNetworkGet, ChannelkartNetworkPost, ChannelkartNetworkPut } from "../../../services/networkService";
import store from "../../../stateManagement/store";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { getLob } from "../../../services/authenticationService";
import ReportOtp from "../reportsMainPage/ReprotOtp";
import { maskEmail } from "../../otpVerification/otpVerificationUtils";
import { setDownloadCount,addDownload,setShowDownload,removeDownload, updateDownload ,removeCancelDownload,showCancelPopup,removeRetryDownload,refreshDownload} from "../../../stateManagement/actions/downloadBarActions";
import { useDispatch } from "react-redux";
import { downloadBarReducer } from "../../../stateManagement/reducers/downloadBarReducer";


const ReportsTile = (props: reportListObject) => {
  const navigate = useNavigate();
  const {translate} = usePortalTranslation();
  const dispatch=useDispatch();
  const CUR_COMPONENT = "Reports"
  const CUR_COMPONENT_COMMON="commonPortal";
  const [showConfirmPopup,setShowConfirmPopup] = useState<boolean>(false);
  const [showReportModal, setShowReportModal] = useState<boolean>(false);
  const [loading,setLoading]=useState<boolean>(false);
  const downloads = useSelector(() => store.getState().downloadBarReducer.downloads);
  const showDownload = useSelector((state:any) => state.downloadBarReducer.showDownload);
  const retryDownloads = useSelector(() => store.getState().downloadBarReducer.retryDownloads);
   useEffect(()=>{
    if(props.downloadCount!==undefined&&props.setReportLoader){
        props.downloadCount>=3?props.setReportLoader(true):props.setReportLoader(false);
    }
  },[props.downloadCount]);

   useEffect(()=>{
    if(props.downloadCount!==undefined&&props.downloadCount===0&&downloads.length>0&&!showDownload){
      dispatch(refreshDownload())
    }
  },[downloads,showDownload])
  
  useEffect(()=>{
    const retryClick=retryDownloads.find((d) => d === props.id);
    if(retryClick){
      navigateToDownloadPage(props)
      dispatch(removeRetryDownload(props.id));
    }
  },[retryDownloads])
  // const [showPasswordModal, setShowPasswordModal] = useState<boolean>(false);
  // const [password, setPassword] = useState<string>("");
  // const setReportPassword = async () => {
  //   try {
  //     const networkService = store
  //       .getState()
  //       .serviceRegistry.get("ChannelkartNetwork");
  //     // const encryptedPassword = password;
  //     const encryptedPassword = await networkService.encrypt(new Date().getTime() + ":" + password);
  //     const requestBody: any = {
  //       reportPassword: encryptedPassword,
  //     };
  //     const response = await ChannelkartNetworkPut("/users/reportpassword", requestBody);
  //     if (response?.status === 200) {
  //       props.setNeedPassword(false);
  //       setPassword("");
  //     } else {
  //       console.error("Failed to set the report password. Response:", response);
  //       setPassword("");
  //     }
  //   } catch (error) {
  //     // props.setNeedPassword(false);
  //     setPassword("");
  //     console.error("An error occurred while setting the report password:", error);
  //   }
  // };
  const [reportPassword, setReportPass] = useState<string>("");

  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [showPasswordModal, setShowPasswordModal] = useState<boolean>(false);
  const [showPasswordConfirmModal, setShowPasswordConfirmModal] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const validatePassword = (password: string) => ({
    length: password.length >= 8 && password.length <= 20,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    symbol: /[@$!%*?&]/.test(password),
  });

  const validations = validatePassword(reportPassword);
  const allValid = Object.values(validations).every(Boolean);
  const passwordsMatch = reportPassword === confirmPassword;
  const setReportPassword = async () => {
    try {
      const networkService = store
        .getState()
        .serviceRegistry.get("ChannelkartNetwork");
      const encryptedPassword = await networkService.encrypt(
        reportPassword
      );
      const headers:any={
        // otp:headerOtp,
        sessionID:sessionIDVerify
      }
      const requestBody: any = { reportPassword: encryptedPassword };
      const response = await ChannelkartNetworkPut(
        "/users/reportpassword",
        requestBody,
        headers
      );
      if (response?.status === 200) {
        props.setNeedPassword(false);
        props.setPasswordQuery(false)
        setReportPass("");
        setConfirmPassword("");
        openPopup(
          "Success",
          "Your password has been created successfully. You can now securely access your reports"
        );
        window.location.reload();
      } else {
        console.error("Failed to set the report password. Response:", response);
        setReportPass("");
        setConfirmPassword("");
      }
    } catch (error) {
      setReportPass("");
      setConfirmPassword("");
      console.error(
        "An error occurred while setting the report password:",
        error
      );
    }
  };
  
  const fileFormat = useSelector((state: { fileFormat: fileFormat }) => state.fileFormat.fileFormat) ?? "xlsx";
  const navigateToDownloadPage = (props: reportListObject) => {
   let latestDownloads=store.getState().downloadBarReducer.downloads;
    const isAlreadyDownloading = latestDownloads?.some(d => d.id === props.id);
    const inProgress = latestDownloads?.some(
      (d) => d.id === props.id && (d.statusList.includes("INPROGRESS"))
    );
    if (inProgress||loading) {
      openPopup("Alert", "This report is already being downloaded.");
    }
    else if(props.reportLoader){
       openPopup("Alert","You can download a maximum of 3 reports at a time. Please download in batches.");
    }
   else if ((props.filter || props.globalFilters)) {
      setShowReportModal(true);
    }
    else if(!inProgress&&isAlreadyDownloading){
      downloadReportWithoutFilters(props.id,fileFormat,props.report)
    }
     else if (!props.reportLoader) {
      setShowConfirmPopup(true)
    }

  };
  const addOrUpdateDownload=(id:string,name:string)=>{
    const existingDownload =downloads.find((d) => d.id === id);
    if(existingDownload){
      dispatch(updateDownload(id,[],0))
    }
    else{
      dispatch(addDownload({id,name,statusList:[],totalRecordsCount:0}))
    }
  }
  
  const downloadReportWithStatus = async (idList: Record<string, any>, failedIds: string[]) => {
     let latestCancelledDownloads = store.getState().downloadBarReducer.cancelledDownloads;
     
    if(latestCancelledDownloads.includes(props.id)){
      dispatch(removeCancelDownload(props.id))
      return;
    }
    let latestDownloads=store.getState().downloadBarReducer.downloads;
    let statusList: string[] = [];
    let records:number=0
    const existingDownload =latestDownloads.find((d) => d.id === props.id);
    for (const id of [...Object.keys(idList)]) {
      try{
      const res = await task(id);
      let data = res.data.features[0];
      if (data.status !== 'SUCCESS' && data.status !== 'INPROGRESS') {
        
        failedIds.push(idList[id]);
        delete idList[id];
      }
      statusList.push(data.status);
      records=res?.data?.features[0]?.attributes?.totalRecordsCount??existingDownload?.totalRecordsCount;
    }
    catch(err){
      dispatch(setDownloadCount(-1));
      dispatch(showCancelPopup(false));
      dispatch(updateDownload(props.id,["FAILURE"],0));
      return;
    }
    }
    if (statusList.some((status) => (status === 'INPROGRESS'||status==="SUCCESS")))
    dispatch(updateDownload(props.id,statusList,records));
    else
    dispatch(updateDownload(props.id,statusList,0));

    if (statusList.every((status) => status === 'SUCCESS')) {
      Object.keys(idList).forEach((id, index) => {
        setTimeout(() => {
          downloadReportOfID(id);
        }, index * 200);
      });
      latestCancelledDownloads = store.getState().downloadBarReducer.cancelledDownloads;
      if(latestCancelledDownloads.includes(props.id)){
        dispatch(removeCancelDownload(props.id));
        return;
    }
    dispatch(removeDownload(props.id));
    dispatch(setDownloadCount(-1));
      // if (props.setReportLoader) props.setReportLoader(false);
      // if (failedIds.length > 0) {
        
      //   const reportNames = failedIds.length<=1 ? props.name : failedIds.join(", ");
      //   openPopup("Error", `Something went wrong with ${reportNames} report`);
      // }
    } else if (statusList.some((status) => status === 'INPROGRESS')) {
       latestCancelledDownloads = store.getState().downloadBarReducer.cancelledDownloads;
      if(latestCancelledDownloads.includes(props.id)){
        dispatch(removeCancelDownload(props.id))
        return;
    }
      setTimeout(() => downloadReportWithStatus(idList, failedIds), (2000));
    }
    else {
      latestCancelledDownloads = store.getState().downloadBarReducer.cancelledDownloads;
      if(latestCancelledDownloads.includes(props.id)){
      dispatch(removeCancelDownload(props.id));
      return;
    }
    dispatch(setDownloadCount(-1));
    dispatch(showCancelPopup(false));
      // if (props.setReportLoader) props.setReportLoader(false);
      // if (failedIds.length > 0) {
        
      //   const reportNames = failedIds.length<=1 ? props.name : failedIds.join(", ") ;
      //   openPopup("Error", `Something went wrong with ${reportNames} report`);
      // }
    }
  };

  const callMethod = async (requestBodyList: downloadReportRequestBody[]) => {
    let idList: Record<string, any> = [];
    for (const requestBody of requestBodyList) {
      if (Object.keys(requestBody).length > 0) {
        try{
        const response = await downloadReport(requestBody);
        idList[response.data.id] = requestBody.attributes.name;
        }
        catch(err){
          setLoading(false);
          return;
        }
      }
      if(requestBody.attributes.emailReportEnabled){
        return;
      }
    };
    addOrUpdateDownload(props.id,props.name);
    dispatch(setDownloadCount(1));
    dispatch(setShowDownload(true));
    downloadReportWithStatus(idList, []);
  }

  const callNewReportMethod = async (requestBodyList: downloadReportRequestBody[]) => {
    for (const requestBody of requestBodyList) {
      if (Object.keys(requestBody).length > 0) {
        try {
          // Get the logged-in user's login ID (distributorCodes)
          const loggedInUser = JSON.parse(localStorage.authContext).user.loginId;
          
          const newReportRequestBody: NewReportRequestBody = {
            configName: requestBody.attributes.name || '',
            params: {
              distributorCodes: loggedInUser
            }
          };

          console.log("New Report Request:", newReportRequestBody);
          console.log("Original Request Body:", requestBody);

          const response = await downloadNewReport(newReportRequestBody);
          
          // Handle file download
          const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `${requestBody.attributes.name}.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          
          openPopup("Success", `${requestBody.attributes.name} downloaded successfully!`);
        } catch (error) {
          console.error("Error calling new report API:", error);
          openPopup("Error", `Failed to download ${requestBody.attributes.name}`);
        }
      }
    }
  };


  const downloadReportWithoutFilters = async (id: string, fileFormat: string, report: Record<string, any>, selectedLiveFilter?: string) => {
    setLoading(true);
    let requestBodyList: downloadReportRequestBody[] = [];
    const userEmail = JSON.parse(localStorage.authContext).user.email;
    if ("innerReportsIds" in report) {
      for (const key of report?.innerReportsIds) {
        let newAttributes: downloadReportAttributes = {
          name: key,
          format: fileFormat,
          loggedInUserName: JSON.parse(localStorage.authContext).user.loginId,
        };
        
        // Append _api to report name for new reports with past3months or custom filter
        if (report?.isNewReport === true && (selectedLiveFilter === 'past3months' || selectedLiveFilter === 'custom')) {
          newAttributes.name = newAttributes.name + '_api';
        }
        
        let requestBody: downloadReportRequestBody = {
          attributes: newAttributes,
          lob: localStorage.lob,
        };
        
        if (report?.isNewReport === true) {
          const loggedInUser = JSON.parse(localStorage.authContext).user.loginId;
          const filterObj = requestBody.attributes.filter as any;
          
         // Check if filters are present in the attributes
          const hasFilters = filterObj && 
                            filterObj.filters && 
                            Array.isArray(filterObj.filters) && 
                            filterObj.filters.length > 0;
          
          if (hasFilters) {
           // If filter is present and isNewReport == true, append distributorCodes to the filters array
            filterObj.filters.push({
              key: 'distributor_codes',
              value: loggedInUser
            });
          } else {
           // If filter object doesn't exist, create the structure
            requestBody.attributes.filter = {
              filters: [
                {
                  key: 'distributor_codes',
                  value: loggedInUser
                }
              ]
            };
          }
        }
        
        requestBodyList.push(requestBody);
      };
    }
    else {
      let newAttributes: downloadReportAttributes = {
        name: id,
        format: fileFormat,
        loggedInUserName: JSON.parse(localStorage.authContext).user.loginId,
      };
      
      // Append _api to report name for new reports with past3months or custom filter
      if (report?.isNewReport === true && (selectedLiveFilter === 'past3months' || selectedLiveFilter === 'custom')) {
        newAttributes.name = newAttributes.name + '_api';
      }
      
      let requestBody: downloadReportRequestBody = {
        attributes: newAttributes,
        lob: localStorage.lob,
      };
      
      if (report?.isNewReport === true) {
        const loggedInUser = JSON.parse(localStorage.authContext).user.loginId;
        const filterObj = requestBody.attributes.filter as any;
        
       // Check if filters are present in the attributes
        const hasFilters = filterObj && 
                          filterObj.filters && 
                          Array.isArray(filterObj.filters) && 
                          filterObj.filters.length > 0;
        
       if (hasFilters) {
         // If filter is present and isNewReport == true, append distributorCodes to the filters array
          filterObj.filters.push({
            key: 'distributor_codes',
            value: loggedInUser
          });
        } else {
         // If filter object doesn't exist, create the structure
          requestBody.attributes.filter = {
            filters: [
              {
                key: 'distributor_codes',
                value: loggedInUser
              }
            ]
          };
        }
      }
      
      requestBodyList.push(requestBody);
    }

    // Email report logic (unified)
    if (report.emailReportEnabled === true) {
      for (const requestBody of requestBodyList) {
        requestBody.attributes.emailRecipient = userEmail;
        requestBody.attributes.emailReportEnabled = true;
      }
      if (props.setReportLoader) props.setReportLoader(false);
      openPopup("Success", "The report will be sent to your email.");
    }

    // Use new report method if report.isNewReport is true, otherwise use the old method
    // if (report.isNewReport === true) {
    //   await callNewReportMethod(requestBodyList);
    // } else {
    //   await callMethod(requestBodyList);
    // }
    await callMethod(requestBodyList);
    setLoading(false);
  }
  const [toggleState, setToggleState] = useState<boolean>(false);
  const [email, setEmail] = useState<string>(JSON.parse(localStorage.authContext).user.email);
  const [sessionID, setSessionID] = useState("");
  const [sessionIDVerify, setSessionIDVerify] = useState("");
  const [verifyOTPModal, setVerifyOTPModal] = useState<boolean>(false);
  const [otpLength, setOtpLength] = useState(6);
  const [isverifiedOtp, setisverifiedOtp] = useState(false);
  const [contactAddressType, setcontactAddressType] = useState("email");
  const sendOtp = async () => {
    setToggleState(!toggleState);
    const contactAddress: string = email;

    if(contactAddress.trim().length === 0){
      openPopup("Error", `Please enter valid email`);
      setToggleState(false);
      return;
    }
    const lob = getLob();
    if (contactAddress && lob) {
      try {
        localStorage.setItem("lob", lob);
        // const response = await sendForgotPasswordOtpAddress(
        //   contactAddress,
        //   "email"
        // );
        const response = await ChannelkartNetworkPost("/v1/otp/send/resource", {
          email: email,
          // countryCode: countryCode,
          resourceURL:"v1/otp/verify/resource"
        })
        
        if (response?.status === 200) {
          setSessionID(response?.data?.response?.sessionId)
          setVerifyOTPModal(true)
        } else {
          openPopup("Error", "Please retry after sometime");
        }
      } catch (error) {
        openPopup(
          "Error",
          `Email is not registered with us. Please contact support for assistance!`
        );
      }
    } else {
      openPopup(
        "Alert",
        contactAddress ? "Please Enter lob" : "Please Enter contact number"
      );
    }
    setToggleState(false);
  };
  const verifyOtp = async (otp:string) => {
    if (otp && otp.length === otpLength) {
      // setHeaderOtp(otp)
      // setVerifyOTPModal(false)
      // setValidateUserModal(false)
      // setChangePasswordModal(true);
      // return
      try {
        const response = await ChannelkartNetworkPost("/v1/otp/verify/resource", {
          otpString: otp,
          sessionID:sessionID,
          resourceURL:"/users/reportpassword"
        })

        if (response.data?.statusCode == 200) {
          setSessionIDVerify(response?.data?.sessionId)
          setVerifyOTPModal(false)
          setShowPasswordModal(true);
          return {result :true , message:'Success'};
        } else {
          return {result :false , message:"Please enter the correct OTP"};
        }
      } catch (error) {
        return {result :false , message:"Please enter the correct OTP"};
      }
    } else {
      return {result : false , message:"Enter complete OTP"};
    }
  };

  const onSuccess = ()=>{
    setisverifiedOtp(true);
  }

  const onFailure = (message:string)=>{
    setisverifiedOtp(false);
    openPopup("Error", message);
  }

  const resendOtp = async () => {
    try{
      const response = await ChannelkartNetworkPost("/v1/otp/send/resource", {
        email: email,
        // countryCode: countryCode,
        resourceURL:"v1/otp/verify/resource"
      })
      if (response?.status === 200) {
        setSessionID(response?.data?.response?.sessionId)
      }
  }catch(error:any){
    openPopup("Error", error.message  ?? "RESEND OTP ERROR");
    console.error(error);
  }
  };


  return (
    <>
    <Grid className="grid" md={6} lg={3} sm={12}>
      <Box onClick={() => { props.needPassword ? setShowPasswordConfirmModal(true) : navigateToDownloadPage(props)}} className="paper">
        <Box className="inner-tile">
          <Typography style={{fontSize: "17px"}}>{translate(TranslationEnum.reports,props.name)}</Typography>
        </Box>

        <Box className="arrow-icon">
          <RenderSvg name="downloadIcon" />
        </Box>
      </Box>
      <ConfirmationPopUp
        message={translate(TranslationEnum.common_portal, "Are you sure want to download {name} Report",{"name":props.name})}
        openConfirmModal={showConfirmPopup}
        successMethod={() => {
          downloadReportWithoutFilters(props.id, fileFormat, props.report);
        }}
        setOpenConfirmModal={setShowConfirmPopup}
      />
      {showReportModal && <ReportDownloadModal
        report={props.report}
        id={props.id}
        name={props.name}
        type={props.type}
        filter={props.filter}
        parentFilter={props.parentFilter}
        showReportModal={showReportModal}
        setShowReportModal={setShowReportModal}
        globalFilters={props.globalFilters}
        batchDownload={props.batchDownload}
      />}
    </Grid>
      {/* <Modal
        centered
        withCloseButton={false}
        overlayOpacity={0.55}
        overlayBlur={3}
        opened={showPasswordModal}
        onClose={() => setShowPasswordModal(false)}
        radius="lg"
        size="420px"
        className="confirmationPopUp-modalContainer"
      >
        <div className="modal-content" style={{
          display: "flex", flexDirection: "column", alignItems: "center"
        }}>
          <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "10px",
            width: "38px",
            height: "38px",
            borderRadius: "50%",
            backgroundColor: "#1c7ea0",
            padding: "5px"
          }}>
            <svg stroke="white" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" width="20" height="20" xmlns="http://www.w3.org/2000/svg">
              <polyline points="9 11 12 14 22 4"></polyline>
              <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
            </svg>
          </div>
          <p style={{ textAlign: "center", color: "#909090", fontSize: "16px", marginBottom: "1em" }}>Set Report Password</p>
            <TextField
              sx={{
                width: '70%'
              }}
              size="small"
              placeholder={"Enter Password"}
              value={password}
              onChange={(event) => {
               setPassword( event.target.value)
              }}
              label="Password"
            />
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "1rem" }}>
            <Button
              onClick={() => {
                if (password) {
                  setShowPasswordModal(false);
                  setReportPassword();
                }
              }}
              disabled={!password}
              variant="contained"
              color="primary"
              style={{ width: "fit-content", backgroundColor: password && "#24c6b1" }}
            >
              Continue
            </Button>
          </div>

        </div>
      </Modal> */}
      <Modal
      centered
      withCloseButton={false}
      overlayOpacity={0.55}
      overlayBlur={3}
      opened={showPasswordModal}
      onClose={() => setShowPasswordModal(false)}
      radius="lg"
      size="420px"
      className="confirmationPopUp-modalContainer"
    >
      <div
        className="modal-content"
        style={{ display: "flex", flexDirection: "column",overflow:"auto" ,padding:"10px"}}
      >
        <div style={{ display: "flex",alignItems:"center"}}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // marginRight: "10px",
            width: "38px",
            height: "38px",
            borderRadius: "50%",
            // backgroundColor: "#1c7ea0",
            padding: "5px",
          }}
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 57 57" fill="none">
              <g clip-path="url(#clip0_1546_28067)">
                <path d="M30.6827 54.5314H8.98879C8.52182 54.5314 8.05941 54.4395 7.62798 54.2608C7.19655 54.0821 6.80454 53.8201 6.47434 53.4899C6.14414 53.1597 5.88221 52.7677 5.70351 52.3363C5.52481 51.9049 5.43285 51.4425 5.43286 50.9755V3.55593C5.43286 2.61284 5.8075 1.70837 6.47437 1.04151C7.14124 0.374642 8.0457 0 8.98879 0L26.1388 0C27.0819 -5.62172e-06 27.9863 0.374622 28.6532 1.04147L42.1312 14.5195C42.7981 15.1864 43.1727 16.0909 43.1728 17.034V54.1945L30.6827 54.5314Z" fill="#F0D5A9" />
                <path d="M12.0811 21.2709H36.5244" stroke="#D6AE73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.0811 26.098H36.5244" stroke="#D6AE73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.0811 30.9249H24.3027" stroke="#D6AE73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M27.6116 0.319519C27.9997 0.49552 28.3527 0.740305 28.6536 1.04204L42.131 14.5194C42.4327 14.8203 42.6775 15.1734 42.8535 15.5615H31.0126C30.1107 15.5614 29.2456 15.203 28.6078 14.5652C27.97 13.9274 27.6117 13.0624 27.6116 12.1604V0.319519Z" fill="#E2BE8A" />
                <circle cx="43" cy="47" r="11" fill="white" />
                <path d="M40.4999 42.8333C40.4999 42.1703 40.7633 41.5344 41.2322 41.0656C41.701 40.5967 42.3369 40.3333 42.9999 40.3333C43.663 40.3333 44.2988 40.5967 44.7677 41.0656C45.2365 41.5344 45.4999 42.1703 45.4999 42.8333V44.5H47.1666V42.8333C47.1666 41.7283 46.7276 40.6685 45.9462 39.8871C45.1648 39.1057 44.105 38.6667 42.9999 38.6667C41.8948 38.6667 40.835 39.1057 40.0536 39.8871C39.2722 40.6685 38.8333 41.7283 38.8333 42.8333V44.5H40.4999V42.8333Z" fill="#BCBEC0" />
                <path d="M47.1666 44.5H38.8333C38.1702 44.5 37.5343 44.7634 37.0655 45.2322C36.5966 45.7011 36.3333 46.337 36.3333 47V52.8333C36.3333 53.4964 36.5966 54.1323 37.0655 54.6011C37.5343 55.0699 38.1702 55.3333 38.8333 55.3333H47.1666C47.8296 55.3333 48.4655 55.0699 48.9344 54.6011C49.4032 54.1323 49.6666 53.4964 49.6666 52.8333V47C49.6666 46.337 49.4032 45.7011 48.9344 45.2322C48.4655 44.7634 47.8296 44.5 47.1666 44.5ZM43.8333 51.1667C43.8333 51.3877 43.7455 51.5996 43.5892 51.7559C43.4329 51.9122 43.2209 52 42.9999 52C42.7789 52 42.5669 51.9122 42.4107 51.7559C42.2544 51.5996 42.1666 51.3877 42.1666 51.1667V48.6667C42.1666 48.4457 42.2544 48.2337 42.4107 48.0774C42.5669 47.9211 42.7789 47.8333 42.9999 47.8333C43.2209 47.8333 43.4329 47.9211 43.5892 48.0774C43.7455 48.2337 43.8333 48.4457 43.8333 48.6667V51.1667Z" fill="#FFAC33" />
              </g>
              <defs>
                <clipPath id="clip0_1546_28067">
                  <rect width="57" height="57" fill="white" />
                </clipPath>
              </defs>
            </svg>
        </div>
        <p
          style={{
            textAlign: "center",
            color: "#909090",
            fontSize: "16px",
            marginBottom:"0"
          }}
        >
          Create a password for reports
        </p>
        </div>
        <TextField
          key={"testing"}
          sx={{
            width: "100%",
            marginTop:"10px"
          }}
          size="small"
          placeholder="Enter Password"
          value={reportPassword}
          onChange={(event) => setReportPass(event.target.value)}
          label="Password"
          type={showPassword ? "text" : "password"}
          InputProps={{
            endAdornment: (
              <IconButton
                onClick={() => setShowPassword((prev) => !prev)}
                edge="end"
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            ),
          }}
        />
        <div style={{ width: "100%", marginTop: "1rem" }}>
          <ul style={{ listStyle: "none", padding: 0 }}>
            <li style={{ color: validations.length ? "green" : "red" }}>
              {validations.length ? "✔" : "✖"} Must be 8-20 Characters
            </li>
            <li style={{ color: validations.uppercase ? "green" : "red" }}>
              {validations.uppercase ? "✔" : "✖"} Include Uppercase Letters (A-Z)
            </li>
            <li style={{ color: validations.lowercase ? "green" : "red" }}>
              {validations.lowercase ? "✔" : "✖"} Include Lowercase Letters (a-z)
            </li>
            <li style={{ color: validations.number ? "green" : "red" }}>
              {validations.number ? "✔" : "✖"} Include Numbers (0-9)
            </li>
            <li style={{ color: validations.symbol ? "green" : "red" }}>
              {validations.symbol ? "✔" : "✖"} Include Symbols (@$!%*?&)
            </li>
          </ul>
        </div>
        <TextField
          sx={{
            width: "100%",
          }}
          size="small"
          placeholder="Re-enter Password"
          value={confirmPassword}
          onChange={(event) => setConfirmPassword(event.target.value)}
          label="Re-enter Password"
          error={!passwordsMatch && confirmPassword !== ""}
          type={showConfirmPassword ? "text" : "password"}
          InputProps={{
            endAdornment: (
              <IconButton
                onClick={() => setShowConfirmPassword((prev) => !prev)}
                edge="end"
              >
                {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            ),
          }}
        />
        {confirmPassword && !passwordsMatch && (
          <p style={{ color: "red", marginTop: "0.5rem" }}>
            Passwords do not match
          </p>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "1rem",
          }}
        >
          <Button
             onClick={() => {
              setShowPasswordModal(false);
              setReportPassword();
            }}
            disabled={!allValid || !passwordsMatch}
            variant="contained"
            color="primary"
            style={{
              width: "100%",
              backgroundColor: allValid && passwordsMatch ? "#24c6b1" : "#ccc",
            }}
          >
            Set Password
          </Button>
        </div>
      </div>
    </Modal>

    <Modal
      centered
      withCloseButton={false}
      overlayOpacity={0.55}
      overlayBlur={3}
      opened={showPasswordConfirmModal}
      onClose={() => setShowPasswordConfirmModal(false)}
      radius="lg"
      size="420px"
      className="confirmationPopUp-modalContainer"
    >
      <div
        className="modal-content"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "20px",
          overflow:"auto"
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "10px",
            // width: "38px",
            // height: "38px",
            // backgroundColor: "#1c7ea0",
            // padding: "5px",
          }}
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 57 57" fill="none">
              <g clip-path="url(#clip0_1546_28067)">
                <path d="M30.6827 54.5314H8.98879C8.52182 54.5314 8.05941 54.4395 7.62798 54.2608C7.19655 54.0821 6.80454 53.8201 6.47434 53.4899C6.14414 53.1597 5.88221 52.7677 5.70351 52.3363C5.52481 51.9049 5.43285 51.4425 5.43286 50.9755V3.55593C5.43286 2.61284 5.8075 1.70837 6.47437 1.04151C7.14124 0.374642 8.0457 0 8.98879 0L26.1388 0C27.0819 -5.62172e-06 27.9863 0.374622 28.6532 1.04147L42.1312 14.5195C42.7981 15.1864 43.1727 16.0909 43.1728 17.034V54.1945L30.6827 54.5314Z" fill="#F0D5A9" />
                <path d="M12.0811 21.2709H36.5244" stroke="#D6AE73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.0811 26.098H36.5244" stroke="#D6AE73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.0811 30.9249H24.3027" stroke="#D6AE73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M27.6116 0.319519C27.9997 0.49552 28.3527 0.740305 28.6536 1.04204L42.131 14.5194C42.4327 14.8203 42.6775 15.1734 42.8535 15.5615H31.0126C30.1107 15.5614 29.2456 15.203 28.6078 14.5652C27.97 13.9274 27.6117 13.0624 27.6116 12.1604V0.319519Z" fill="#E2BE8A" />
                <circle cx="43" cy="47" r="11" fill="white" />
                <path d="M40.4999 42.8333C40.4999 42.1703 40.7633 41.5344 41.2322 41.0656C41.701 40.5967 42.3369 40.3333 42.9999 40.3333C43.663 40.3333 44.2988 40.5967 44.7677 41.0656C45.2365 41.5344 45.4999 42.1703 45.4999 42.8333V44.5H47.1666V42.8333C47.1666 41.7283 46.7276 40.6685 45.9462 39.8871C45.1648 39.1057 44.105 38.6667 42.9999 38.6667C41.8948 38.6667 40.835 39.1057 40.0536 39.8871C39.2722 40.6685 38.8333 41.7283 38.8333 42.8333V44.5H40.4999V42.8333Z" fill="#BCBEC0" />
                <path d="M47.1666 44.5H38.8333C38.1702 44.5 37.5343 44.7634 37.0655 45.2322C36.5966 45.7011 36.3333 46.337 36.3333 47V52.8333C36.3333 53.4964 36.5966 54.1323 37.0655 54.6011C37.5343 55.0699 38.1702 55.3333 38.8333 55.3333H47.1666C47.8296 55.3333 48.4655 55.0699 48.9344 54.6011C49.4032 54.1323 49.6666 53.4964 49.6666 52.8333V47C49.6666 46.337 49.4032 45.7011 48.9344 45.2322C48.4655 44.7634 47.8296 44.5 47.1666 44.5ZM43.8333 51.1667C43.8333 51.3877 43.7455 51.5996 43.5892 51.7559C43.4329 51.9122 43.2209 52 42.9999 52C42.7789 52 42.5669 51.9122 42.4107 51.7559C42.2544 51.5996 42.1666 51.3877 42.1666 51.1667V48.6667C42.1666 48.4457 42.2544 48.2337 42.4107 48.0774C42.5669 47.9211 42.7789 47.8333 42.9999 47.8333C43.2209 47.8333 43.4329 47.9211 43.5892 48.0774C43.7455 48.2337 43.8333 48.4457 43.8333 48.6667V51.1667Z" fill="#FFAC33" />
              </g>
              <defs>
                <clipPath id="clip0_1546_28067">
                  <rect width="57" height="57" fill="white" />
                </clipPath>
              </defs>
            </svg>
        </div>
        <p
          style={{
            textAlign: "center",
            color: "#909090",
            fontSize: "16px",
            marginBottom: "1em",
          }}
        >
          Your reports are encrypted for security. <br /> Set a password now to access them securely.
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            marginTop: "20px",
          }}
        >
          <Button
            variant="outlined"
            onClick={() => {setShowPasswordConfirmModal(false);props.setPasswordQuery(true)}}
          >
            Skip for Now
          </Button>
          <Button
            variant="contained"
            onClick={() => {setShowPasswordConfirmModal(false); sendOtp()}}
          >
            Set Password
          </Button>
        </div>
      </div>
    </Modal>
    <Modal
      centered
      withCloseButton={false}
      overlayOpacity={0.55}
      overlayBlur={3}
      opened={verifyOTPModal}
      onClose={() => {setVerifyOTPModal(false); setConfirmPassword("");setReportPass("")}}
      radius="lg"
      size="420px"
      className="confirmationPopUp-modalContainer"
    >
      <div
        className="modal-content"
        style={{ display: "flex", flexDirection: "column",overflow:"auto"}}
      >
         <div style={{ display: "flex",alignItems:"center"}}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // marginRight: "10px",
            width: "38px",
            height: "38px",
            borderRadius: "50%",
            // backgroundColor: "#1c7ea0",
            padding: "5px",
          }}
        >
           <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 57 57" fill="none">
              <g clip-path="url(#clip0_1546_28067)">
                <path d="M30.6827 54.5314H8.98879C8.52182 54.5314 8.05941 54.4395 7.62798 54.2608C7.19655 54.0821 6.80454 53.8201 6.47434 53.4899C6.14414 53.1597 5.88221 52.7677 5.70351 52.3363C5.52481 51.9049 5.43285 51.4425 5.43286 50.9755V3.55593C5.43286 2.61284 5.8075 1.70837 6.47437 1.04151C7.14124 0.374642 8.0457 0 8.98879 0L26.1388 0C27.0819 -5.62172e-06 27.9863 0.374622 28.6532 1.04147L42.1312 14.5195C42.7981 15.1864 43.1727 16.0909 43.1728 17.034V54.1945L30.6827 54.5314Z" fill="#F0D5A9" />
                <path d="M12.0811 21.2709H36.5244" stroke="#D6AE73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.0811 26.098H36.5244" stroke="#D6AE73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.0811 30.9249H24.3027" stroke="#D6AE73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M27.6116 0.319519C27.9997 0.49552 28.3527 0.740305 28.6536 1.04204L42.131 14.5194C42.4327 14.8203 42.6775 15.1734 42.8535 15.5615H31.0126C30.1107 15.5614 29.2456 15.203 28.6078 14.5652C27.97 13.9274 27.6117 13.0624 27.6116 12.1604V0.319519Z" fill="#E2BE8A" />
                <circle cx="43" cy="47" r="11" fill="white" />
                <path d="M40.4999 42.8333C40.4999 42.1703 40.7633 41.5344 41.2322 41.0656C41.701 40.5967 42.3369 40.3333 42.9999 40.3333C43.663 40.3333 44.2988 40.5967 44.7677 41.0656C45.2365 41.5344 45.4999 42.1703 45.4999 42.8333V44.5H47.1666V42.8333C47.1666 41.7283 46.7276 40.6685 45.9462 39.8871C45.1648 39.1057 44.105 38.6667 42.9999 38.6667C41.8948 38.6667 40.835 39.1057 40.0536 39.8871C39.2722 40.6685 38.8333 41.7283 38.8333 42.8333V44.5H40.4999V42.8333Z" fill="#BCBEC0" />
                <path d="M47.1666 44.5H38.8333C38.1702 44.5 37.5343 44.7634 37.0655 45.2322C36.5966 45.7011 36.3333 46.337 36.3333 47V52.8333C36.3333 53.4964 36.5966 54.1323 37.0655 54.6011C37.5343 55.0699 38.1702 55.3333 38.8333 55.3333H47.1666C47.8296 55.3333 48.4655 55.0699 48.9344 54.6011C49.4032 54.1323 49.6666 53.4964 49.6666 52.8333V47C49.6666 46.337 49.4032 45.7011 48.9344 45.2322C48.4655 44.7634 47.8296 44.5 47.1666 44.5ZM43.8333 51.1667C43.8333 51.3877 43.7455 51.5996 43.5892 51.7559C43.4329 51.9122 43.2209 52 42.9999 52C42.7789 52 42.5669 51.9122 42.4107 51.7559C42.2544 51.5996 42.1666 51.3877 42.1666 51.1667V48.6667C42.1666 48.4457 42.2544 48.2337 42.4107 48.0774C42.5669 47.9211 42.7789 47.8333 42.9999 47.8333C43.2209 47.8333 43.4329 47.9211 43.5892 48.0774C43.7455 48.2337 43.8333 48.4457 43.8333 48.6667V51.1667Z" fill="#FFAC33" />
              </g>
              <defs>
                <clipPath id="clip0_1546_28067">
                  <rect width="57" height="57" fill="white" />
                </clipPath>
              </defs>
            </svg>
        </div>
        <p
          style={{
            color: "#909090",
            fontSize: "16px",
            marginBottom: "0",
          }}
        >
           Verify your identity
        </p>
        </div>
        <ReportOtp
            OtpVerficationHeader={
              <div className="otp-label" style={{color:"black",fontWeight:500,paddingBlock:"20px"}}>
                 {translate(TranslationEnum.validate_otp,"OTP sent to your registered {phoneNumber}",{"phoneNumber":contactAddressType === "sms" ? "Phone Number" : "Email ID"})} &nbsp;
                {
                email && maskEmail(email)
                }
              </div>
            }
            onFailure={onFailure}
            onSuccess={onSuccess}
            resendOtp={resendOtp}
            verifyOTP={verifyOtp}
            otpLength={otpLength}
          />
      </div>
    </Modal> 

    </>
  );
};

export default ReportsTile;